module.exports = __webpack_public_path__ + "img/letter-k.883291f6.svg";